import classnames from 'classnames';
import React from 'react';
import { pickDomAttrs } from '../_util/utils';
import Typography from '../typography';
import { useDescriptionConfig } from './container';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Row = props => {
  const {
    title,
    subtitle,
    description,
    extra,
    info,
    help,
    tips,
    children,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-container-row");
  const attrs = pickDomAttrs(restProps);
  const {
    sidebarWidth
  } = useDescriptionConfig(description);
  return /*#__PURE__*/_jsxs("div", {
    ...attrs.data,
    className: classnames(baseClassName, className),
    style: style,
    children: [/*#__PURE__*/_jsx("div", {
      className: "".concat(baseClassName, "-content"),
      children: /*#__PURE__*/_jsx(Typography, {
        level: "h5",
        title: title,
        subtitle: subtitle,
        extra: extra,
        info: info,
        help: help,
        tips: tips,
        children: children
      })
    }), !!description && /*#__PURE__*/_jsx("div", {
      className: "".concat(baseClassName, "-description"),
      style: {
        width: sidebarWidth,
        right: sidebarWidth * -1
      },
      children: description
    })]
  });
};
export const RowItem = props => {
  const {
    title,
    subtitle,
    description,
    info,
    help,
    tips,
    extra,
    children,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style
  } = props;
  const baseClassName = "".concat(prefixClass, "-container-block");
  const {
    sidebarWidth
  } = useDescriptionConfig(description);
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(baseClassName, className),
    style: style,
    children: [/*#__PURE__*/_jsx("div", {
      className: "".concat(baseClassName, "-content"),
      children: /*#__PURE__*/_jsx(Typography, {
        level: "h6",
        title: title,
        subtitle: subtitle,
        extra: extra,
        info: info,
        help: help,
        tips: tips,
        children: children
      })
    }), !!description && !!sidebarWidth && /*#__PURE__*/_jsx("div", {
      className: "".concat(baseClassName, "-description"),
      style: {
        width: sidebarWidth,
        right: sidebarWidth * -1
      },
      children: description
    })]
  });
};